import { View, Text, Pressable } from "react-native";
import { Link } from "expo-router";

interface ProfileStatsBarProps {
  followerCount: number;
  followingCount: number;
  eventCount: number;
  userId: string;
}

export function ProfileStatsBar({
  followerCount,
  followingCount,
  eventCount,
  userId,
}: ProfileStatsBarProps) {
  return (
    <View className="mx-6 mt-2 mb-6 rounded-2xl bg-white/10 px-4 py-3">
      <View className="flex-row items-center justify-around">
        <Link asChild href={`/user/${userId}/followers?tab=followers`}>
          <Pressable
            className="items-center active:opacity-70"
            accessibilityRole="button"
            accessibilityLabel="Ver seguidores"
          >
            <Text className="text-primary text-base font-bold">
              {followerCount}
            </Text>
            <Text className="text-muted-foreground text-sm">Seguidores</Text>
          </Pressable>
        </Link>
        <View className="bg-primary/40 h-8 w-px" />
        <Link asChild href={`/user/${userId}/followers?tab=following`}>
          <Pressable
            className="items-center active:opacity-70"
            accessibilityRole="button"
            accessibilityLabel="Ver seguindo"
          >
            <Text className="text-primary text-base font-bold">
              {followingCount}
            </Text>
            <Text className="text-muted-foreground text-sm">Seguindo</Text>
          </Pressable>
        </Link>
        <View className="bg-primary/40 h-8 w-px" />
        <Link asChild href={`/user/${userId}/events`}>
          <Pressable
            className="items-center active:opacity-70"
            accessibilityRole="button"
            accessibilityLabel="Ver eventos"
          >
            <Text className="text-primary text-base font-bold">
              {eventCount}
            </Text>
            <Text className="text-muted-foreground text-sm">Eventos</Text>
          </Pressable>
        </Link>
      </View>
    </View>
  );
}
